module.exports = __webpack_public_path__ + "static/img/Logo_PIPE_EAGLE.05bfa7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/Logo_PIPE_EAGLE.png
// module id = 1631
// module chunks = 6